export default __webpack_public_path__ + "static/weather--rain-a98504840a1e568583669cde8e04276c.png";